<!--
 * @Descripttion: 我的订单页面组件
 * @Author: congz
 * @Date: 2020-07-03 18:01:05
 * @LastEditors: congz
 * @LastEditTime: 2020-08-19 10:55:03
--> 

<template>
  <div class="order" id="order" name="order">
    <!-- UPI Payment Dialog -->
    <el-dialog
      title="Scan to Pay"
      :visible.sync="paymentDialogVisible"
      width="400px"
      center
      :close-on-click-modal="false"
      @close="handleDialogClose"
    >
      <div v-if="paymentLoading" class="payment-loading">
        <i class="el-icon-loading"></i>
        <p>Generating payment code...</p>
      </div>
      <div v-else class="payment-content">
        <div class="payment-amount">
          <span class="label">Amount to Pay</span>
          <span class="amount">{{currentOrder ? currentOrder.discount_price * currentOrder.num : 0}}₹</span>
        </div>
        <div class="qr-code">
          <img :src="qrCodeUrl" alt="UPI QR Code" @load="qrCodeLoaded = true" v-show="qrCodeLoaded" />
          <div v-if="!qrCodeLoaded" class="qr-loading">
            <i class="el-icon-loading"></i>
          </div>
        </div>
        <div class="payment-info">
          <p class="merchant-name">VIRELLA INFORMATICS (OPC) PRIVATE LIMITED</p>
          <p class="order-ref">Order: {{currentOrder ? currentOrder.order_num : ''}}</p>
        </div>
        <div class="payment-steps">
          <p><i class="el-icon-mobile-phone"></i> Open any UPI app (Google Pay, PhonePe, Paytm)</p>
          <p><i class="el-icon-scan"></i> Scan the QR code above</p>
          <p><i class="el-icon-check"></i> Complete payment</p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handlePaymentCancel">Cancel</el-button>
        <el-button type="primary" @click="handlePaymentComplete" :loading="paymentCompleteLoading">Payment Done</el-button>
      </span>
    </el-dialog>

    <div class="order-layout">
      <el-row :gutter="10">
        <div>
          <CenterMenu></CenterMenu>
        </div>
        <el-col :span="20">
          <div class="order-content">
            <div class="extra"></div>
            <!--我的订单头部-->
            <div class="order-title">
              <p>My Order
              </p>
            </div>
            <div class="order-select">
              <router-link :to="{ path: '/order'}">
                <span :class="type==0?'select':'no-select'">All Valid Orders</span>
              </router-link>
              <span class="cut">|</span>
              <router-link :to="{ path: '/order', query: {type:1} }">
                <span :class="type==1?'select':'no-select'">Awaiting Shipment</span>
              </router-link>
              <!-- <span class="cut">|</span>
              <router-link :to="{ path: '/order', query: {type:2} }">
                <span :class="type==2?'select':'no-select'">Paid</span>
              </router-link> -->
              <span class="cut">|</span>
              <span class="no-select">Order Recycle Bin</span>
              <div class="search">
                <el-input placeholder="Enter the product name and order number" v-model="search">
                  <el-button slot="append" icon="el-icon-search" @click="searchClick"></el-button>
                </el-input>
              </div>
            </div>
            <div v-if="orders.length>0">
              <!--我的订单头部 end-->
              <!--订单列表-->
              <div class="order-list" v-for="(item,index) in orders" :key="index">
                <div class="order-list-head">
                  <div class="order-pay" v-if="item.type !== 2">Awaiting payment
                  </div>
                  <div class="order-pay" v-else>Paid</div>
                  <div class="order-info">
                    <div style="width:650px;">
                      <span class="info">{{item.created_at | dateFormat}}</span>
                      <span class="cut">|</span>
                      <span class="info">{{item.address_name}}</span>
                      <span class="cut">|</span>
                      <span class="info">Order Number：{{item.order_num}}</span>
                      <span class="cut">|</span>
                      <span class="info">{{item.payment_method === 'online' ? 'Online payment' : 'Cash on Delivery'}}</span>
                    </div>
                    <span class="info" style="margin-left:30px">Amount</span>
                    <span class="money">{{item.discount_price*item.num}}</span>
                    <span class="info">₹</span>
                  </div>
                </div>
                <div class="order-list-product">
                  <div class="pro-img">
                    <router-link
                      :to="{ path: '/goods/details', query: {productID:item.product_id} }"
                    >
                      <img :src="item.img_path" />
                    </router-link>
                  </div>
                  <div class="pro-info">
                    <p style="margin-bottom:7px">
                      <router-link
                        class="info-href"
                        :to="{ path: '/goods/details', query: {productID:item.product_id} }"
                      >{{item.name}}</router-link>
                    </p>
                    <span>{{item.discount_price}}</span>&nbsp;×
                    <span>{{item.num}}</span>
                  </div>
                  <div class="operate">
                    <div v-if="item.type !== 2">
                      <el-button class="button-pay" @click="handlePayNow(item)">Pay Now</el-button>
                    </div>
                    <div>
                      <router-link
                        :to="{ path: '/order/details', query: {orderNum:item.order_num} }"
                      >
                        <el-button plain class="button-detail">Details
                        </el-button>
                      </router-link>
                    </div>
                    <div v-if="item.type==2">
                      <el-button type="info" class="button-detail">Delete Order
                      </el-button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 分页 -->
              <div class="pagination">
                <el-pagination
                  background
                  @current-change="handleCurrentChange"
                  :page-size="pageSize"
                  layout="total, prev, pager, next, jumper"
                  :total="total"
                ></el-pagination>
              </div>
              <div class="extra"></div>
              <div class="extra"></div>
            </div>
            <!-- 分页END -->
            <!-- 订单为空的时候显示的内容 -->
            <div v-else class="empty">
              <p>You have not purchased any products yet
              </p>
              <p>Go shopping now !</p>
            </div>
            <!-- 订单为空的时候显示的内容END -->
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import CenterMenu from '../components/CenterMenu'
import * as ordersAPI from '@/api/orders'
export default {
  name: 'Order',
  data() {
    return {
      orders: [], // 订单列表
      pageSize: 5,
      total: 0,
      start: 0,
      limit: 5,
      type: '',
      paymentDialogVisible: false,
      paymentLoading: false,
      paymentCompleteLoading: false,
      qrCodeUrl: '',
      qrCodeLoaded: false,
      currentOrder: null
    }
  },
  activated() {
    if (this.$route.query.type != undefined) {
      this.type = this.$route.query.type
    } else {
      this.type = 0
    }
  },
  watch: {
    // 监听订单类型的变化，请求后端获取商品数据
    type: function() {
      this.getOrders()
    }
  },
  methods: {
    handleCurrentChange(val) {
      this.start = this.limit * (val - 1) // val 页面
      this.getOrders()
    },
    getOrders() {
      // 获取订单数据
      ordersAPI
        .listOrders(
          this.$store.getters.getUser.id,
          this.type,
          this.start,
          this.limit
        )
        .then(res => {
          if (res.status === 200) {
            this.orders = res.data.items
            this.total = res.data.total
          } else if (res.status === 20001) {
            //token过期，需要重新登录
            this.loginExpired(res.msg)
          } else {
            this.notifyError('Failed to obtain order', res.msg)
          }
        })
        .catch(err => {
          this.notifyError('Failed to obtain order', err)
        })
    },
    // Handle Pay Now button click — redirect to payment page
    handlePayNow(order) {
      this.$router.push({ path: '/pay', query: { orderNum: order.order_num } })
    },
    // Generate UPI QR code URL
    generateUpiQrCode() {
      const amount = this.currentOrder.num * this.currentOrder.discount_price
      const orderId = this.currentOrder.order_num
      const upiUrl = `upi://pay?pa=admin@virellastore.in&pn=VIRELLA%20INFORMATICS%20(OPC)%20PRIVATE%20LIMITED&am=${amount}&cu=INR&tn=Order_${orderId}`
      this.qrCodeUrl = `https://api.qrserver.com/v1/create-qr-code/?size=250x250&data=${encodeURIComponent(upiUrl)}`
      this.paymentLoading = false
    },
    // Handle dialog close
    handleDialogClose() {
      this.paymentDialogVisible = false
      this.paymentLoading = false
      this.qrCodeLoaded = false
      this.qrCodeUrl = ''
      this.currentOrder = null
    },
    // Cancel payment
    handlePaymentCancel() {
      this.paymentDialogVisible = false
    },
    // Confirm payment completed（纯展示版：不允许支付成功）
    handlePaymentComplete() {
      this.notifyError('Not payment')
    }
  },
  components: {
    CenterMenu
  }
}
</script>
<style scoped>
.order-layout {
  max-width: 1225px;
  margin: 0 auto;
}
.order-content {
  background-color: #ffffff;
  margin-bottom: 30px;
}
.order-title {
  height: 100px;
  display: flex;
  align-items: center;
}
.order-title p {
  font-size: 30px;
  color: #757575;
  margin-left: 50px;
}
.extra {
  height: 10px;
}
.order-select {
  width: 920px;
  margin: 0 auto;
  display: flex;
  align-items: center;
}
.order-select .no-select {
  font-size: 17px;
  color: #757575;
  margin-right: 10px;
}
.order-select .select {
  font-size: 17px;
  color: #3E8E5A;
  margin-right: 10px;
}
.order-select .cut {
  font-size: 22px;
  color: #c9c7c7;
  margin-right: 15px;
  font-weight: 300;
}
.order-select .search {
  width: 300px;
  margin-left: 225px;
}
/*订单头部*/
.order-list-head {
  height: 100px;
  background-color: #FFF9F0;
  width: 920px;
  margin: 0 auto;
  margin-top: 20px;
  border-left: 1px solid #3E8E5A;
  border-right: 1px solid #3E8E5A;
  border-top: 1px solid #3E8E5A;
  border-bottom: 1px solid #C9E8C3;
}
.order-list-head .order-pay {
  font-size: 19px;
  color: #3E8E5A;
  margin-left: 30px;
  margin-top: 20px;
  margin-bottom: 10px;
}
.order-list-head .order-success-pay {
  font-size: 19px;
  color: #00a724;
  margin-left: 30px;
  margin-top: 20px;
  margin-bottom: 10px;
}
.order-list-head .order-info {
  width: 860px;
  margin: 0 auto;
  margin-top: 5px;
  display: flex;
  align-items: center;
}
.order-list-head .order-info .info {
  font-size: 15px;
  color: #757575;
}
.order-list-head .order-info .cut {
  font-size: 17px;
  color: #c9c7c7;
  margin-left: 10px;
  margin-right: 10px;
  font-weight: 300;
}
.order-list-head .order-info .money {
  font-size: 25px;
  color: #000000;
  margin-right: 5px;
  margin-left: 10px;
}
/*订单头部END*/
/*订单商品*/
.order-list-product {
  height: 130px;
  background-color: #ffffff;
  width: 920px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  border-left: 1px solid #3E8E5A;
  border-right: 1px solid #3E8E5A;
  border-bottom: 1px solid #3E8E5A;
}
.order-list-product .pro-img {
  margin-left: 30px;
  margin-right: 20px;
}
.order-list-product .pro-img img {
  height: 80px;
  width: 80px;
}
.order-list-product .pro-info {
  width: 500px;
  font-size: 15px;
  color: #333333;
}
.order-list-product .pro-info .info-href {
  font-size: 15px;
  color: #333333;
}
.order-list-product .pro-info .info-href:hover {
  color: #3E8E5A;
}
.order-list-product .operate {
  line-height: 50px;
  margin-left: 150px;
}
.order-list-product .operate .button-pay {
  width: 100px;
  color: #ffffff;
  background: linear-gradient(135deg, #3E8E5A 0%, #5FA96C 100%);
  border: none;
}
.order-list-product .operate .button-pay:hover {
  background: linear-gradient(135deg, #7C22D9 0%, #5B1A8F 100%);
}

.order-list-product .operate .button-detail {
  width: 100px;
}
/*订单商品END*/
.order-content .pagination {
  width: 300px;
  margin: 0 auto;
  margin-top: 20px;
}
.empty {
  width: 200px;
  margin: 0 auto;
  padding-top: 50px;
  padding-bottom: 60px;
  color: #bdbaba;
  font-size: 18px;
}

/* 手机端适配 */
@media (max-width: 900px) {
  .order-layout {
    max-width: 100%;
  }
  .order-title {
    height: auto;
    padding: 12px;
  }
  .order-title p {
    margin-left: 0;
    font-size: 22px;
  }
  .order-select {
    width: 100%;
    padding: 0 12px;
    flex-wrap: wrap;
    row-gap: 6px;
  }
  .order-select .search {
    width: 100%;
    margin-left: 0;
  }
  .order-list-head,
  .order-list-product {
    width: 100%;
  }
  .order-list-head .order-info {
    width: 100%;
    padding: 0 12px;
    flex-wrap: wrap;
    gap: 6px 8px;
  }
  .order-list-product {
    height: auto;
    padding: 12px;
    flex-wrap: wrap;
  }
  .order-list-product .pro-img {
    margin-left: 0;
    margin-right: 12px;
  }
  .order-list-product .pro-img img {
    width: 64px;
    height: 64px;
    border-radius: 6px;
  }
  .order-list-product .operate {
    margin-left: auto;
    line-height: normal;
  }
  .order-content .pagination {
    width: 100%;
  }
}

/* Payment Dialog Styles */
.payment-loading {
  text-align: center;
  padding: 40px 0;
}
.payment-loading i {
  font-size: 48px;
  color: #3E8E5A;
}
.payment-loading p {
  margin-top: 16px;
  color: #666;
}
.payment-content {
  text-align: center;
}
.payment-amount {
  margin-bottom: 20px;
  padding: 16px;
  background: #FFF9F0;
  border-radius: 12px;
}
.payment-amount .label {
  display: block;
  font-size: 12px;
  color: #666;
  margin-bottom: 4px;
}
.payment-amount .amount {
  display: block;
  font-size: 32px;
  font-weight: 700;
  color: #3E8E5A;
}
.qr-code {
  margin: 20px auto;
  width: 250px;
  height: 250px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border: 2px solid #FFF9F0;
  border-radius: 12px;
}
.qr-code img {
  width: 220px;
  height: 220px;
}
.qr-loading {
  text-align: center;
}
.qr-loading i {
  font-size: 36px;
  color: #3E8E5A;
}
.payment-info {
  margin: 16px 0;
}
.payment-info .merchant-name {
  font-size: 16px;
  font-weight: 600;
  color: #2D2D2D;
}
.payment-info .order-ref {
  font-size: 12px;
  color: #888;
  margin-top: 4px;
}
.payment-steps {
  text-align: left;
  background: #f9f9f9;
  padding: 16px;
  border-radius: 8px;
  margin-top: 16px;
}
.payment-steps p {
  font-size: 13px;
  color: #666;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.payment-steps p:last-child {
  margin-bottom: 0;
}
.payment-steps i {
  color: #3E8E5A;
  font-size: 16px;
}
</style>
